<template>
  <div class="LookElectornic">
    <van-popup v-model="show" @click-overlay="handleClick" @click="handleClick">
      <img :src="getOcrUrl(urlImg)" alt="" class="img">
    </van-popup>
    <!-- <div @click="handleLookTel(urlImg)">
      查看电子档案
    </div> -->
  </div>
</template>
<script>
import { Popup } from 'vant'
import { THUMBNAIL_CONFIG } from '@/assets/config'
export default {
  data () {
    return {
      show: false
    }
  },
  mounted () {
    this.show = this.imgShow
  },
  methods: {
    // handleLookTel () {
    //   this.show = true
    // }
    handleClick () {
      console.log('点击l')
      this.$emit('update:imgShow', false)
    }
  },
  watch: {
    imgShow (v) {
      this.show = v
    }
  },
  props: {
    urlImg: {

    },
    imgShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getOcrUrl () {
      return (url) => {
        if (url) {
          let index = url.indexOf('http')
          let newUrl = url
          console.log(index)
          if (index === -1) {
            newUrl = 'http://huisuiyun.oss-cn-shanghai.aliyuncs.com/' + url
          }
          newUrl = THUMBNAIL_CONFIG(newUrl)
          return newUrl
        }
      }
    }
  },
  components: {
    [Popup.name]: Popup
  }
}
</script>
<style scoped lang='less'>
.LookElectornic{
  position: fixed;
  padding: 24px;
  z-index: 99;
  box-sizing: border-box;
  width: 100%;
  left: 0px;
  bottom: 0px;
  height: 128px;
  // background: #fff;
  /deep/.van-popup--center{
    img{
      width: 100%;
    }
  }

  div{
    margin: 0 auto;
    height: 80px;
    background: #3378FF;
    color: #fff;
    text-align: center;
    line-height: 80px;
    font-size: 28px;
    border-radius: 4px;
  }
  /deep/.van-popup--center{
    z-index: 2002;
    height: 300px;
    width: 100%;
    background: transparent;
  }
}
</style>
